export default class Titel {
    public titel: number | null = null;
    public prevTitel: number | null = null;

    constructor(data?: Partial<Titel>) {
        Object.assign(this, data);
    }
}
